// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environment: 'dev',
  firebaseConfig:  {
    apiKey: 'AIzaSyCqWyAeD5C_GEg9ZHSjpjkewIcsKnMbcQY',
    authDomain: 'dihola-engine-dev.firebaseapp.com',
    databaseURL: 'https://dihola-engine-dev.firebaseio.com',
    projectId: 'dihola-engine-dev',
    storageBucket: 'dihola-engine-dev.appspot.com',
    messagingSenderId: '23004577843',
    appId: '1:23004577843:web:57c0049e61527348f2a346'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
